export default __webpack_public_path__ + "static/2-2-2-0-ad688d550b7a3f3a1f938d9bd68d3e7f.jpg";